<!-- components/QuestionCard.vue -->
<template>
  <el-card class="question-card" shadow="hover">
    <div class="header">
      <el-tag size="small" :type="getTagType(question.type)">
        {{ question.type }}
      </el-tag>
      <el-tag size="small" :type="getDifficultyTag(question.difficulty)">
        {{ question.difficulty }}
        ({{ question.difficultyScore }})
      </el-tag>
      <el-tag size="small" type="warning">{{ question.source }}</el-tag>
    </div>

    <div class="content" v-html="renderedContent"></div>

    <div class="footer">
      <el-button type="text" @click="showAnswer = !showAnswer">
        {{ showAnswer ? '隐藏答案' : '查看答案' }}
      </el-button>
      <el-button type="text" @click="showSimilar">相似题</el-button>
      <el-button type="text" @click="showDetail">详情</el-button>
      <el-button type="text" @click="showListDialog = true">收藏至题单</el-button>
      <el-button type="primary" size="small" @click="addToBasket">
        加入试题篮
      </el-button>
    </div>

    <div v-if="showAnswer" class="answer" v-html="renderedAnswer"></div>
    <SelectListDialog v-model="showListDialog" :questionId="question.id" />
  </el-card>
</template>

<script setup>
import { ref, onMounted } from 'vue'
//   import { renderMath } from '@/utils/mathRenderer'
import SelectListDialog from './SelectListDialog.vue'

const props = defineProps({
  question: {
    type: Object,
    required: true
  }
})

const showAnswer = ref(false)
const renderedContent = ref('')
const renderedAnswer = ref('')
const showListDialog = ref(false)

onMounted(async () => {
  // renderedContent.value = await renderMath(props.question.content)
  // if (props.question.answer) {
  //   renderedAnswer.value = await renderMath(props.question.answer)
  // }
})

const getTagType = (type) => {
  const map = {
    单选题: 'primary',
    多选题: 'success',
    填空题: 'info',
    解答题: 'warning',
    判断题: 'danger'
  }
  return map[type] || 'default'
}

const getDifficultyTag = (difficulty) => {
  const map = {
    容易: 'success',
    较易: 'info',
    适中: 'warning',
    较难: 'danger',
    困难: 'primary'
  }
  return map[difficulty] || 'default'
}

const showSimilar = () => {
  alert(`展示相似题：${props.question.id}`)
}

const showDetail = () => {
  alert(`查看详情：${props.question.id}`)
}

const addToBasket = () => {
  emit('add-to-basket', props.question)
  ElMessage.success('已加入试题篮')
}

const emit = defineEmits(['add-to-basket'])
</script>

<style scoped>
.question-card {
  margin-bottom: 16px;
}

.header {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
}

.content {
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 16px;
}

.footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px dashed #eee;
}

.answer {
  margin-top: 12px;
  padding: 12px;
  background-color: #f9f9f9;
  border-radius: 4px;
  font-weight: bold;
}
</style>